type QueryValue =
  | string
  | number
  | readonly (string | number)[]
  | undefined
  | null
  | boolean;

interface BuildQueryOptions {
  delimiter?: string;
  multiKeys?: Record<string, string>;
}

export const buildQueryParams = (
  input: Record<string, QueryValue> | string,
  options?: BuildQueryOptions,
): string => {
  const params = new URLSearchParams();
  const delimiter = options?.delimiter ?? '-';
  const multiKeys = options?.multiKeys ?? {};

  if (typeof input === 'string') {
    const searchParams = new URLSearchParams(input);

    for (const [key, value] of searchParams.entries()) {
      if (!value) continue;

      if (key in multiKeys && value.includes(delimiter)) {
        value.split(delimiter).forEach((segment) => {
          params.append(multiKeys[key], segment);
        });
      } else {
        params.append(key, value);
      }
    }
  } else {
    for (const [key, value] of Object.entries(input)) {
      if (value == null) continue;
      const valuesArray: (string | number)[] = Array.isArray(value)
        ? value
        : [value];

      valuesArray.forEach((singleValue) => {
        const stringValue = String(singleValue);

        if (key in multiKeys && stringValue.includes(delimiter)) {
          stringValue.split(delimiter).forEach((segment) => {
            params.append(multiKeys[key], segment);
          });
        } else {
          params.append(key, stringValue);
        }
      });
    }
  }

  return params.toString();
};
